<template>
  <el-container class="index-con" direction="vertical">
    <el-header class="index-header">
      <div class="header-brand">
        <!-- <img class="header-logo" :src="logoImg" alt="" /> -->
        <span class="header-brand-text">{{ platformTitle }}</span>
      </div>
      <div class="header-right">
        <navcon></navcon>
      </div>
    </el-header>
    <el-container class="body-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-main class="index-main" :class="{ 'is-home': isHomePage }">
        <div class="index-content">
          <div class="page-heading" v-if="!isHomePage">
            <div class="page-heading__title">{{ pageTitle }}</div>
            <!-- <div class="page-heading__desc" v-if="pageDesc">{{ pageDesc }}</div> -->
          </div>
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import leftnav from "./leftnav.vue";
import navcon from "./navcon.vue";
import settings from "@/settings";
import contentBg from "@/assets/img/home/welcome-banner.png";
const PAGE_DESC_MAP = {
  课程管理: "管理和维护平台课程内容",
  课程中心: "管理和维护平台课程内容",
  课程详情: "查看课程信息、章节、资料与学员",
  课程信息: "编辑课程基础信息与章节内容",
  题库管理: "管理和维护平台题库内容",
  学员管理: "管理和维护平台学员信息",
  消息中心: "查看与发送系统消息",
  消息管理: "查看与发送系统消息",
  系统管理: "配置用户、角色与系统参数",
  首页: "平台数据总览"
};

export default {
  name: "index",
  data() {
    return {
      contentBg,
      showclass: "asideshow",
      showtype: false,
      platformTitle: settings.title || "培训平台",
      logoImg: require("@/assets/img/login/LOGO.svg")
    };
  },
  components: {
    leftnav,
    navcon
  },
  computed: {
    isHomePage() {
      const path = this.$route.path || "";
      return (
        path === "/home" ||
        path === "/home/index" ||
        (this.$route.meta && this.$route.meta.title === "首页")
      );
    },
    pageTitle() {
      const matched = this.$route.matched || [];
      if (matched.length >= 2 && matched[1].meta && matched[1].meta.title) {
        const moduleTitle = matched[1].meta.title;
        if (
          this.$route.path.includes("/course/detail") ||
          this.$route.path.includes("/course/edit")
        ) {
          return "课程管理";
        }
        return moduleTitle;
      }
      const last = matched[matched.length - 1];
      return (last && last.meta && last.meta.title) || last.name || "";
    },
    pageDesc() {
      return PAGE_DESC_MAP[this.pageTitle] || "";
    }
  },
  methods: {},
  created() {
    this.$root.Bus.$on("toggle", value => {
      if (value) {
        this.showclass = "asideshow";
      } else {
        setTimeout(() => {
          this.showclass = "aside";
        }, 300);
      }
    });
  },
  beforeUpdate() {},
  beforeMount() {}
};
</script>
<style scoped lang="less">
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  // background: linear-gradient(180deg, #eef4ff 0%, #f5f8fd 40%, #f0f4fa 100%);
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 2px 20px 0px rgba(100, 142, 200, 0.08);
}

.index-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px !important;
  padding: 0 24px !important;
  background: #f5f9ff;
  border-bottom: 1px solid rgba(229, 230, 235, 0.8);
  box-shadow: 0 1px 8px rgba(28, 104, 255, 0.04);
  box-sizing: border-box;
  z-index: 10;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.header-logo {
  // width: 40px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
}

.header-brand-text {
  font-size: 28px;
  font-weight: bold;
  color: #3059a3;
  line-height: 1;
}

.header-right {
  flex-shrink: 0;
  margin-left: 16px;
}

.body-con {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: transparent;
}

.aside {
  width: 64px !important;
  height: 100%;
  margin: 0;
  background: transparent;
  overflow: hidden;
  padding: 12px 0 12px 12px;
  box-sizing: border-box;
}
.asideshow {
  width: 260px !important;
  height: 100%;
  background: transparent;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;
}

/deep/ .el-header {
  padding: 0;
}
/deep/ .el-main {
  padding: 0;
  background-color: transparent;
}
.index-main {
  overflow-x: hidden;
  overflow-y: auto;
  min-width: 0;
  min-height: 0;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background: linear-gradient(153deg, #dbeafe 0%, #e9f5fe 45%, #fce7f3 100%);
  position: relative;
}
.index-content {
  min-height: 100%;
  box-sizing: border-box;
  background-image: url("../../assets/img/home/welcome-banner.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 25px 33px;
}
.page-heading {
  margin-bottom: 16px;

  &__title {
    font-size: 22px;
    font-weight: 600;
    color: #1e1b4b;
    line-height: 1.3;
  }

  &__desc {
    margin-top: 4px;
    font-size: 12px;
    color: #6387f1;
    line-height: 1.4;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/index.vue